'use strict';

/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */

// Sheet Component Utilities

// Flag to prevent multiple event listeners from being added - for scenarios where multiple sheet components are on the same page
let escapeKeyListenerAdded = false;

const closeSheetWithEscapeKey = function () {
    if (escapeKeyListenerAdded) {
        return;
    }

    escapeKeyListenerAdded = true;

    document.addEventListener('keydown', (e) => {
        const openSheets = document.querySelectorAll('sheet-component.open');

        if (e.key === 'Escape' || e.code === 'Escape') {
            openSheets.forEach((sheet) => {
                sheet.closeSheet();
            });
        }
    });
};

/**
 * Returns the text content of the first header element (h1, h2, h3, or h4)
 * found in a given element. Useful for rendering a page designer asset in a modal/sheet,
 * where you may want to move the header text elsewhere for more control over the HTML structure.
 *
 * @param {Element} element - The element to search within. Will search for headers within this element.
 * @param {boolean} removeFoundHeader - Boolean indicating whether to remove the header element after retrieving its text.
 * @returns {string|null} The text content of the first header found, or null if none exist.
 */
const getFirstHeaderText = function (element, removeFoundHeader) {
    const firstHeaderElement = element.querySelector('h1, h2, h3, h4');
    if (firstHeaderElement) {
        removeFoundHeader && firstHeaderElement.remove();
        return firstHeaderElement.innerText;
    }
    return null;
};

module.exports = {
    closeSheetWithEscapeKey: closeSheetWithEscapeKey,
    getFirstHeaderText: getFirstHeaderText
};
